<template>
	<div class="resett-wrapper ">
		<div class="login-img" @click="$router.push('/')">
			<img src="@/assets/images/registerLogin.png" alt="">
		</div>
		<div class="reset-content" v-if="this.type == 1">
			<div class="reset-password">
				<div class="reset-password-title">重設密碼</div>
				<div class="reset-password-description">請輸入您用於 LOOPSHOP 的電郵。電郵將用作主要的溝通渠道，包括在顧客成功付款後，讓您接收訂單確認電郵以及在有需要的情況下讓
					LOOPSHOP 主動聯絡您。</div>
				<div for="email" class="reset-password-label">電郵:</div>
				<input type="text" id="email" v-model="email" @input="validateEmail" class="email-input" />
				<div class="error-message" v-if="!isEmailValid">請填写正確的电邮地址</div>
				<div class="continue-btn" @click="continueClicked">繼續</div>
				<div class="establish-btn">建立帳戶</div>
			</div>
			<div class="reset-password-image">
				<img src="@/assets/images/resett.png" alt="">
			</div>
		</div>
		<div class="account-warapper" v-if="this.type == 2">
			<div class="account-message">
				<div class="account-title">帳戶復原電郵已經寄出</div>
				<div class="account-cot">重設密碼電郵已經寄到 testing123@email.com 請細閱並跟從電郵上的指示。</div>
			</div>
			<div class="reset-password-image">
				<img src="@/assets/images/resett.png" alt="">
			</div>
		</div>
		<div class="new-warapper account-warapper" v-if="this.type == 3">
			<div class="new-content">
				<div class="title">重設密碼</div>
				<div class="password-label">新密碼:<label class="password-info">(必須包含數字、小寫、大寫字母)</label></div>

				<input type="password" id="password" v-model="password" @input="validatePassword" class="password-input" />
				<div for="confirm-password" class="confirm-password-label">確認密碼:</div>
				<input type="password" id="confirm-password" v-model="confirmPassword" @input="validateConfirmPassword"
					class="password-input" />
				<div class="confirm-reset">確認並重置</div>
			</div>
			<div class="reset-password-image">
				<img src="@/assets/images/resett.png" alt="">
			</div>
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>
<script>
export default {
	data() {
		return {
			type: 3,
			email: '',
			isEmailValid: true
		}
	},
	methods: {
		validateEmail() {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			this.isEmailValid = emailRegex.test(this.email);
		},
		continueClicked() {
			if (!this.isEmailValid) {
				console.log('Email is valid');
			} else {
				console.log('Email is valid');
			}
		}
	}
}

</script>

<style lang="scss" scoped>
.login-img {
	position: absolute;
	left: 0;
	top: 0;

	img {
		margin-top: 0.16rem;
		margin-left: 0.40rem;
		width: 1.04rem;
		height: 0.48rem;
		display: block;
		cursor: pointer;

		@media (max-width: 768px) {
			margin-top: 0.16rem;
			margin-left: 0.40rem;
			height: auto;
		}
	}
}

.new-warapper {
	display: flex;
	align-items: center;
	// height: 100vh;
	justify-content: flex-end;
	padding: 0.3rem;

	.new-content {
		margin-right: 3.02rem;

		.title {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.40rem;
			line-height: 0.56rem;
			color: #000000;
			margin-bottom: 0.64rem;
		}

		.password-label {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.20rem;
			line-height: 0.28rem;
			color: #000000;
		}

		.password-info {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.16rem;
			line-height: 0.22rem;
			color: #E02E43;
		}

		.password-input {
			width: 5.22rem;
			height: 0.56rem;
			background: #FAFAFA;
			border: 1px solid #999999;
			border-radius: 0.08rem;
			display: block;
			margin-top: 0.08rem;
			margin-bottom: 0.24rem;
			padding: 0 0.2rem;
		}

		.confirm-password-label {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.20rem;
			line-height: 0.28rem;
			color: #000000;

		}

		.confirm-reset {
			background: #E02E43;
			border-radius: 0.08rem;
			width: 5.22rem;
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.24rem;
			line-height: 0.32rem;
			color: #FFFFFF;
			text-align: center;
			margin-top: 0.40rem;
			padding: 0.24rem 0;
		}
	}

	.reset-password-image {
		height: 100%;

		img {
			display: block;
			height: 100%;
		}
	}

}

.account-warapper {
	display: flex;
	align-items: center;
	justify-content: flex-end;

	.account-message {
		margin-right: 3.02rem;

		.account-title {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.40rem;
			line-height: 0.56rem;
			color: #000000;
		}

		.account-cot {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.24rem;
			line-height: 0.34rem;
			color: #666666;
			width: 5.22rem;
			margin-top: 0.24rem;
		}
	}

	.reset-password-image {
		width: 7.76rem;
		border-radius: 0.3rem;
		overflow: hidden;
		height: 100%;

		img {
			width: 100%;
			// height: 100%;
		}
	}
}

.reset-content {
	display: flex;
	align-items: center;
	justify-content: flex-end;

	.reset-password {
		margin-right: 3.02rem;

		.reset-password-title {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.40rem;
			line-height: 0.56rem;
			color: #000000;
		}

		.reset-password-description {
			width: 5.22rem;
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.16rem;
			line-height: 0.22rem;
			color: #666666;
			margin-top: 0.16rem;
		}

		.reset-password-label {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.2rem;
			line-height: 0.28rem;
			color: #000000;
			margin-top: 0.64rem;
			margin-bottom: 0.08rem;

		}

		.email-input {
			width: 5.22rem;
			height: 0.56rem;
			background: #FAFAFA;
			border: 1px solid #999999;
			border-radius: 8px;
			display: block;
		}

		.error-message {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.12rem;
			line-height: 0.16rem;
			color: #B3261E;
			padding-left: 0.24rem;
		}

		.continue-btn {
			width: 5.22rem;
			background: #E02E43;
			border-radius: 0.08rem;
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.24rem;
			color: #FFFFFF;
			padding: 0.24rem;
			text-align: center;
			padding: 0.24rem 0rem;
			margin-top: 0.64rem;

		}

		.establish-btn {
			width: 5.22rem;
			background: #FFFFFF;
			border: 1px solid #E02E43;
			border-radius: 0.08rem;
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.24rem;
			color: #E02E43;
			text-align: center;
			padding: 0.24rem 0rem;
			margin-top: 0.24rem;

		}
	}

	.reset-password-image {
		height: 9rem;
		width: 7.75rem;
		padding: 0.24rem;

		img {
			width: 100%;
			// height: 100%;
		}
	}
}

@media (max-width: 750px) {
	.resett-wrapper .login-img {
		left: 0.4rem;
		top: 0.4rem;
	}

	.resett-wrapper .login-img img {
		height: 0.8rem;
		width: inherit;
		margin: 0;
	}

	.new-warapper .reset-password-image {
		display: none;
	}

	.new-warapper {
		height: auto;
		display: block;
	}

	.new-warapper .new-content {
		margin: 0;
		padding-top: 2rem;
	}

	.new-warapper .new-content .password-label {
		font-size: 0.32rem;
		line-height: 0.32rem;
		margin-bottom: 0.2rem;
	}

	.new-warapper .new-content .password-info,
	.new-warapper .new-content .confirm-password-label {
		font-size: 0.32rem;
		line-height: 0.32rem;
	}

	.confirm-password-label {
		margin-top: 0.4rem;
		margin-bottom: 0.2rem;
	}

	.new-warapper .new-content .password-input {
		width: 100%;
		height: 0.9rem;
	}

	.new-warapper .new-content .confirm-reset {
		background: #E02E43;
		border-radius: 0.16rem;
		height: 1rem;
		font-family: "PingFang HK";
		font-style: normal;
		font-weight: 600;
		font-size: 0.4rem;
		color: #FFFFFF;
		width: 100%;
		line-height: 1rem;
		cursor: pointer;
		display: block;
		padding: 0;
		margin-top: 1rem;
	}
}
</style>
